module.exports = __webpack_public_path__ + "static/media/1013230.51f10520.png";